// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22uW_","top":"styles_top__3ZLoO","left":"styles_left__2syQj","description":"styles_description__1nTsk"};